import { CheckoutState } from '../../state';
import { hasPrepaymentQuestions } from './pureSelectors';

export const areAsyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) => !hasPrepaymentQuestions(state);
